import React from 'react';

const PolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-600">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-slate-800 rounded-3xl shadow-xl border border-slate-700 p-8">
          <h1 className="text-3xl font-bold text-white mb-6 text-center">
            Политика конфиденциальности
          </h1>
          
          <div className="text-slate-300 text-sm mb-8 text-center">
            Дата размещения: 14 августа 2025
          </div>
          
          <div className="space-y-6 text-slate-300 leading-relaxed">
            <p>
              Настоящая Политика конфиденциальности описывает, какие персональные данные собираются при использовании платформы 
              <span className="text-[#7538d5] font-semibold"> "Сделка и Точка"</span> (dealtochka.com), а также каким образом они обрабатываются, хранятся и передаются.
            </p>
            
            <div className="space-y-6">
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">1. Общие положения</h2>
                <div className="space-y-3">
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">1.1. Оператором персональных данных является:</h3>
                    <div className="bg-slate-700 rounded-lg p-4 border border-slate-600">
                      <div className="text-white font-semibold">ООО "ИКС ДРАЙВ"</div>
                      <div className="text-slate-300 text-sm mt-1">
                        ИНН: 7842222864, КПП: 784201001, ОГРН: 1247800055436.
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <h3 className="text-[#7538d5] font-medium text-lg mb-2">1.2. Настоящая Политика разработана в соответствии с требованиями Федерального закона №152-ФЗ "О персональных данных".</h3>
                  </div>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">2. Собираемые персональные данные</h2>
                <p className="mb-3">Мы можем собирать и обрабатывать следующие данные:</p>
                <ul className="list-disc list-inside space-y-1 ml-4 mb-4">
                  <li>Фамилия, имя, отчество;</li>
                  <li>Номер телефона;</li>
                  <li>Паспортные данные;</li>
                  <li>ИНН.</li>
                </ul>
                <p>
                  Данные собираются при регистрации и использовании платформы, в том числе через автоматизированные сервисы идентификации 
                  (например, МТС ID, T-ID и другие), с которыми у нас заключены действующие договоры.
                </p>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">3. Цель обработки персональных данных</h2>
                <p className="mb-3">Персональные данные обрабатываются исключительно в целях:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Предоставления доступа к сервису "Сделка и Точка";</li>
                  <li>Идентификации пользователей;</li>
                  <li>Выполнения требований законодательства;</li>
                  <li>Проведения финансовых операций в рамках работы с банком-партнёром.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">4. Хранение и защита данных</h2>
                <p className="mb-3">Все персональные данные хранятся:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>На защищённых серверах, размещённых на территории Российской Федерации;</li>
                  <li>На оборудовании, сертифицированном по требованиям ФСТЭК России в соответствии с 152-ФЗ;</li>
                  <li>С использованием современных методов защиты, предотвращающих несанкционированный доступ, изменение, раскрытие или уничтожение данных.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">5. Передача персональных данных</h2>
                <p className="mb-3">Передача персональных данных третьим лицам допускается исключительно:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>По требованию суда;</li>
                  <li>По запросу правоохранительных или надзорных органов;</li>
                  <li>В рамках взаимодействия с банком ООО "Банк Точка".</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">6. Срок хранения данных</h2>
                <p>
                  Персональные данные хранятся в течение срока использования платформы и не менее 3 лет после последнего взаимодействия, 
                  если иное не предусмотрено законодательством РФ.
                </p>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">7. Права субъекта персональных данных</h2>
                <p className="mb-3">Пользователь вправе:</p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Запрашивать информацию об обработке своих данных;</li>
                  <li>Требовать изменения или удаления данных;</li>
                  <li>Отозвать согласие на обработку, направив запрос на 
                    <span className="text-[#7538d5] font-semibold"> support@dealtochka.com</span>.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="mt-8 pt-6 border-t border-slate-700 text-center">
            <div className="text-slate-400 text-sm">
              ООО "ИКС ДРАЙВ" • ИНН: 7842222864 • КПП: 784201001 • ОГРН: 1247800055436
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyPage;
